import React, { useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { joinEntryTarget } from '../lib/joinFlow';

export default function Register() {
  const location = useLocation();
  const [storedCode] = useState(() => {
    try { return sessionStorage.getItem('validatedTeamCode'); } catch { return null; }
  });
  return <Navigate to={joinEntryTarget(location.search, storedCode)} replace />;
}
